import React from 'react';
import {useLocation} from "react-router-dom";
import coversData from '../json/covers.json';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Covers from '../components/Covers';

const Tags = () => {
  const location = useLocation();
  const url = location.pathname;
  const tag = url.substring(url.lastIndexOf('tag/') + 4, url.length).replace(/_/g, ' ');
  const coversFiltered = coversData.filter(cover => cover?.tags?.includes(tag));
  const noTags = coversFiltered.length === 0;

  return (
    <div className="page-content">
      <Header />
      <h1 id="page-title">3D Comics - Tag: {noTags ? "not found" : tag}</h1>
      <div className="page-top">
        <Covers variant={'3d'} tag={tag} />
      </div>
      <h1 id="page-title">AI Photos - Tag: {noTags ? "not found" : tag}</h1>
      <div className="page-top">
        <Covers variant={'ai'} tag={tag} />
      </div>
      <Footer />
    </div>
  );
}

export default Tags;
